import { call, put, takeLatest } from 'redux-saga/effects';
import {
  OTP_VERIFY_REQUEST,
  OTP_VERIFY_FAILURE,
  OTP_RESEND_REQUEST,
  OTP_RESEND_FAILURE,
  otpVerifySuccess,
  setResetToken,
} from './actions';
import { push } from 'connected-react-router';
import { post } from '../../utils/api';
import swal from 'sweetalert';
import { handleApiError } from '../../utils/handleApiError';

function* otpVerifyRequest({ payload }) {
  const otp = parseInt(payload.otp);
  const token = payload.token;
  try {
    const response = yield call(
      post,
      '/forgot-password-verify-otp',
      { otp: otp, token: token },
      null
    );

    yield put(setResetToken(response.data.token));
    yield put(otpVerifySuccess());
    yield call(swal, 'Success', 'OTP verified successfully', 'success');
    yield put(push(`/reset-password?token=${response.data.token}`));
  } catch (error) {
    yield handleApiError(error, OTP_VERIFY_FAILURE);
  }
}

function* otpResend({ payload }) {
  const token = payload.token;
  try {
    const response = yield call(
      post,
      '/forgot-password-resend-otp',
      { token: token },
      null
    );

    yield call(swal, 'Success', 'OTP resend successfully', 'success');
  } catch (error) {
    yield handleApiError(error, OTP_RESEND_FAILURE);
  }
}

export default [
  takeLatest(OTP_VERIFY_REQUEST, otpVerifyRequest),
  takeLatest(OTP_RESEND_REQUEST, otpResend),
];
